module.exports = __webpack_public_path__ + "media/images/flags/4x3/geo-9696038585bd3fc2abc4b13435350ff5.svg";